'use strict';

/**
 * module
 */
import { tab } from './module/_tab';
import { modal } from './module/_modal';
import { video } from './module/_video';

/**
 * fun
 */
const fun = (() => {
    const init = () => {
        tab.init();
        modal.init();
        video.init();

        if($('.game-qa').length > 0) {
            let now = 0;
            let score = 0;
            let is_changing = false;

            $('.game-qa__item.is-active').css('opacity', 1);
            $('.js-answer-game').on('click', event => {
                if(!is_changing) {
                    now++;
                    is_changing = true;

                    score += $(event.currentTarget).data('answer-game');
                    
                    if(now < 10) {
                        $('.game-qa__item.is-active').css('opacity', 0);
                        setTimeout(() => {
                            $('.game-qa__item.is-active').removeClass('is-active');
                            $('.game-qa__item:eq(' + now + ')').addClass('is-active');

                            const h = $('.game-qa__item.is-active').outerHeight();
                            $('.game-qa').height(h);

                            setTimeout(() => {
                                $('.game-qa__item.is-active').css('opacity', 1);

                                setTimeout(() => {
                                    is_changing = false;
                                }, 400);
                            }, 200);
                        }, 400);
                    }
                    else {
                        location.href = './result' + score + '.html'
                    }
                }
            });
        }
    };

    // public
    return {
        init: init
    };
})();

$(() => {
    fun.init();
});
